import React from 'react';
import { Icon, IconStack } from 'js/components';
import { Link } from 'react-router-dom';

function TokenAuthenticationComponent({ signingIn }) {
  return (
    <div id="verify-account-page" className="featured-form">
      <div className="full-page-content">
        <div className="container">
          <div className="content"></div>{' '}
          <div className="page-result page-success">
            {signingIn ? null : (
              <>
                <div className="result-icon">
                  <IconStack className="launch-icon mr-3" fixedWidth>
                    <Icon icon="question" />
                    <Icon
                      icon="question"
                      transform="down-5 left-8 shrink-6 rotate-352"
                    />
                    <Icon
                      icon="question"
                      transform="down-5 right-8 shrink-6 rotate-10"
                    />
                  </IconStack>
                </div>
                <div className="result-body pl-3">
                  <h2>An error occurred</h2>
                  <div>
                    <p>
                      An error occurred while trying to authenticate your
                      account. Please try again.
                    </p>
                    <p>
                      <Link to="/login" className="btn btn-primary">
                        Return to login
                      </Link>
                    </p>
                  </div>
                </div>
              </>
            )}
          </div>
        </div>
      </div>
      <div className="full-page-background" />
    </div>
  );
}

export default TokenAuthenticationComponent;
